
<script setup lang="ts">
import { ref, onMounted } from 'vue';

defineProps({
    embedded: Boolean
})

const dropdown = ref<HTMLDivElement|null>(null)

onMounted(() => {
    dropdown.value?.focus()
})
</script>

<template>
    <div ref="dropdown" class="dropdown" :class="{ embedded }">
        <slot></slot>
    </div>
</template>

<style scoped>
.dropdown {
    position: absolute;
    width: calc(100% - 2rem);
    max-height: calc(100vh - 7rem);
    left: 50%;
    transform: translateX(-50%);
    top: calc(100% + 0.25rem);
    background-color: #ffffff;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 0.05rem;
    padding: 0.5rem;
    outline: none;
    align-items: center;
    overflow: hidden;
    z-index: 50;
    border: 1px solid #cbd5e1;
    box-shadow: 0 12px 30px rgba(15, 23, 42, 0.14);
    box-sizing: border-box;
}

.dropdown.embedded {
    position: relative;
    width: 100%;
    max-height: none;
    left: auto;
    top: auto;
    transform: none;
    background-color: transparent;
    border: 0;
    border-radius: 0;
    padding: 0;
    align-items: stretch;
    overflow: visible;
    box-shadow: none;
}
</style>
